import { FC } from 'react';
import { FlexBox } from '@brg/ui';
import styled, { css } from 'styled-components';
import { LayoutConst } from 'core';

export const HSESansTitleCoolEpicMegoGena = styled.h1<{ 
    isDark?: boolean, 
    isAlumni?: boolean, 
    hide?: boolean, 
    isCliclable?: boolean, 
    smallFont?: boolean, 
    isTagPage?: boolean,
    isModal?: boolean,
    isHSEDesign?: boolean,
 }>`
    font-family: ${({ isHSEDesign }) => isHSEDesign ? 'Hse Sans' : 'Inter'};
    font-weight: 600;
    font-size: ${({ smallFont }) => smallFont ? '70px' : '80px'};
    line-height: ${({ smallFont }) => smallFont ? '70px' : '80px'};
    letter-spacing: -0.005em !important;
    display: ${({ hide}) => hide ? 'none' : 'block'};
    word-break: break-word;
    ${({ isCliclable }) => isCliclable ? css` cursor: pointer;` : null};
    margin-bottom: 0;
    text-transform: ${({ isHSEDesign }) => isHSEDesign ? 'uppercase' : 'lowercase'};
    ${p => p.isAlumni ? css`
    text-align: left;
        font-size: 60px;
    line-height: 70px;
        font-style: normal;
        letter-spacing: -0.01em !important;
    ` : null};
    ${p => p.isDark ? 
        css`
        color: #F4F4F4;
    ` : css`
        color: ${p?.isTagPage ? '#151514' : '#212529'};
    `};
    
    @media (max-width: ${LayoutConst.screen.l_12}px) {
        font-size: 43px;
        line-height: 51px;
    }

    ${({ isModal }) => isModal && css`

        @media (max-width: ${LayoutConst.screen.m}px) {
            font-size: 43px;
            line-height: 51px;
        }

        @media (max-width: ${LayoutConst.screen.s -1}px) {
            font-size: 28px;
            line-height: 34px;
        }
    `};

    @media (max-width: ${LayoutConst.screen.s -1 }px) {
        ${({ isTagPage }) => isTagPage && css`
            font-size: 28px;
            font-weight: 600;
            line-height: 34px;
        `};
    }

    @media (max-width: ${LayoutConst.screen.sm}px) {
        font-size: ${({ isTagPage, isModal }) => isTagPage ? '28px' : isModal ? '22px' : '28px'};
        line-height: ${({ isTagPage, isModal }) => isTagPage ? '34px' : isModal ? '28px' : '34px'};
    }

    @media (max-width: 430px) {
        font-size: ${({ isTagPage, isModal }) => isTagPage ? '28px' : isModal ? '22px' : '28px'};
        line-height: ${({ isTagPage, isModal }) => isTagPage ? '34px' : isModal ? '28px' : '34px'};
    }
`;

export const OnlinesSpaceGrotesk = styled.div`
    // font-family: HSE Sans, sans-serif;
    font-weight: 600;
    font-size: 80px;
    line-height: 80px;
    letter-spacing: -0.005em !important;
    @media (max-width: ${LayoutConst.screen.md}px) {
      font-size: 28px;
      line-height: 34px;
      margin-bottom: 14px;
      letter-spacing: -0.005em !important;
    }
`;

export const IndexTitle: FC = () => {
    return (
        <FlexBox width={'100%'} justify={'center'}>
            <HSESansTitleCoolEpicMegoGena>HSE ART AND DESIGN SCHOOL</HSESansTitleCoolEpicMegoGena>
        </FlexBox>
    );
};
import { FC } from 'react';
import { FlexBox } from '@brg/ui';
import styled, { css } from 'styled-components';
import { LayoutConst } from 'core';

export const HSESansTitleCoolEpicMegoGena = styled.h1<{ 
    isDark?: boolean, 
    isAlumni?: boolean, 
    hide?: boolean, 
    isCliclable?: boolean, 
    smallFont?: boolean, 
    isTagPage?: boolean,
    isModal?: boolean,
    isHSEDesign?: boolean,
 }>`
    font-family: ${({ isHSEDesign }) => isHSEDesign ? 'Hse Sans' : 'Inter'};
    font-weight: 600;
    font-size: ${({ smallFont }) => smallFont ? '70px' : '80px'};
    line-height: ${({ smallFont }) => smallFont ? '70px' : '80px'};
    letter-spacing: -0.005em !important;
    display: ${({ hide}) => hide ? 'none' : 'block'};
    word-break: break-word;
    ${({ isCliclable }) => isCliclable ? css` cursor: pointer;` : null};
    margin-bottom: 0;
    text-transform: ${({ isHSEDesign }) => isHSEDesign ? 'uppercase' : 'lowercase'};
    ${p => p.isAlumni ? css`
    text-align: left;
        font-size: 60px;
    line-height: 70px;
        font-style: normal;
        letter-spacing: -0.01em !important;
    ` : null};
    ${p => p.isDark ? 
        css`
        color: #F4F4F4;
    ` : css`
        color: ${p?.isTagPage ? '#151514' : '#212529'};
    `};
    
    @media (max-width: ${LayoutConst.screen.l_12}px) {
        font-size: 43px;
        line-height: 51px;
    }

    ${({ isModal }) => isModal && css`

        @media (max-width: ${LayoutConst.screen.m}px) {
            font-size: 43px;
            line-height: 51px;
        }

        @media (max-width: ${LayoutConst.screen.s -1}px) {
            font-size: 28px;
            line-height: 34px;
        }
    `};

    @media (max-width: ${LayoutConst.screen.s -1 }px) {
        ${({ isTagPage }) => isTagPage && css`
            font-size: 28px;
            font-weight: 600;
            line-height: 34px;
        `};
    }

    @media (max-width: ${LayoutConst.screen.sm}px) {
        font-size: ${({ isTagPage, isModal }) => isTagPage ? '28px' : isModal ? '22px' : '28px'};
        line-height: ${({ isTagPage, isModal }) => isTagPage ? '34px' : isModal ? '28px' : '34px'};
    }

    @media (max-width: 430px) {
        font-size: ${({ isTagPage, isModal }) => isTagPage ? '28px' : isModal ? '22px' : '28px'};
        line-height: ${({ isTagPage, isModal }) => isTagPage ? '34px' : isModal ? '28px' : '34px'};
    }
`;

export const OnlinesSpaceGrotesk = styled.div`
    // font-family: HSE Sans, sans-serif;
    font-weight: 600;
    font-size: 80px;
    line-height: 80px;
    letter-spacing: -0.005em !important;
    @media (max-width: ${LayoutConst.screen.md}px) {
      font-size: 28px;
      line-height: 34px;
      margin-bottom: 14px;
      letter-spacing: -0.005em !important;
    }
`;

export const IndexTitle: FC = () => {
    return (
        <FlexBox width={'100%'} justify={'center'}>
            <HSESansTitleCoolEpicMegoGena>HSE ART AND DESIGN SCHOOL</HSESansTitleCoolEpicMegoGena>
        </FlexBox>
    );
};
